import { http } from '@frontend/fetch';
import { FeedbackBodyType, EligibilityReportWritebackRequest } from './types';

export const postFeedback = async (body: FeedbackBodyType) =>
  http.post<void>(`insurance-verification/v1/feedback`, body);

export const initiateEligibilityReportWriteback = (
  eligibilityReportWritebackRequest: EligibilityReportWritebackRequest,
  sourceId: string,
  personPMSID: string
) => {
  return http.post<Record<string, never>>(
    `/insurance-verification/v1/${sourceId}/${personPMSID}/insurance-eligibility-report`,
    eligibilityReportWritebackRequest
  );
};
